import { connectStats } from 'instantsearch.js/es/connectors';

// Create the render function
const renderStats = (renderOptions, isFirstRender) => {
    const { nbHits, widgetParams } = renderOptions;
  
    if (isFirstRender) {
      return;
    }

    widgetParams.container.innerHTML = `
      <span>${nbHits} produits trouvés</span>
    `;
  };
  
// Create the custom widget
const customStats = connectStats(renderStats);
  
export default customStats;